import {Coordinates} from '@domain/coordinates';

export function isInLowerHalfOfProductionScheduleItem(mouseCoordinates: Coordinates, productionScheduleItem: SVGGraphicsElement): boolean {
  const heightOfClosestProductionScheduleItem = Number(productionScheduleItem.getAttribute('height'));
  const verticalPositionOfClosestProductionScheduleItem = Number(productionScheduleItem.getAttribute('y'));
  const verticalCenterOfProductionScheduleItem = verticalPositionOfClosestProductionScheduleItem + heightOfClosestProductionScheduleItem / 2;

  return mouseCoordinates.y > verticalCenterOfProductionScheduleItem;
}
